import * as ActionType from "./sourcingRequest.type";

const initialState = {
  sourcingRequests: [],
};

export const sourcingRequestReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionType.GET_SOURCING_REQUESTS:
      return {
        ...state,
        sourcingRequests: action.payload,
      };

    case ActionType.UPDATE_SOURCING_REQUEST:
      return {
        ...state,
        sourcingRequests: state.sourcingRequests.map((data) =>
          data._id === action.payload.id ? action.payload.data : data
        ),
      };

    case ActionType.DELETE_SOURCING_REQUEST:
      return {
        ...state,
        sourcingRequests: state.sourcingRequests.filter(
          (data) => data._id !== action.payload
        ),
      };

    default:
      return state;
  }
};
